<!--
  AEmpty — 빈 상태 (모찌 캐릭터)
  · admin-shared.jsx 의 EmptyMochi 와 동일: <Mochi size={96} expr="sleepy" />
  · characters-a.jsx 의 Mochi 정의 그대로 (찹쌀떡 푹신한 몸 + 졸린 눈 + 분홍 볼)
-->
<template>
  <div class="a-empty">
    <div class="a-empty__icon" aria-hidden="true">
      <!-- Mochi (size=96), expr='sleepy', blush=true -->
      <svg viewBox="0 0 200 240" width="96" height="115" fill="none">
        <!-- Body - squishy puff -->
        <path
          d="M100 90 C 55 90, 30 115, 32 150 C 34 195, 62 218, 100 218 C 138 218, 166 195, 168 150 C 170 115, 145 90, 100 90 Z"
          fill="#FFFFFF" stroke="#E6DCC4" stroke-width="2"
        />
        <!-- Little tuft on top -->
        <path d="M95 90 Q100 78 105 90" fill="none" stroke="#C9C0B2" stroke-width="2.5" stroke-linecap="round" />
        <!-- Soft underside shadow -->
        <ellipse cx="100" cy="200" rx="60" ry="12" fill="#F0E8D2" opacity="0.5" />
        <!-- Face (anchors: ex1=86, ex2=114, ey=138, mx=100, my=152) -->
        <!-- Blush -->
        <g fill="#F5B5A8" opacity="0.7">
          <ellipse cx="84" cy="147" rx="6" ry="3.5" />
          <ellipse cx="116" cy="147" rx="6" ry="3.5" />
        </g>
        <!-- Sleepy eyes (가로선) -->
        <g fill="none" stroke="#1F1A14" stroke-width="3" stroke-linecap="round">
          <line x1="81" y1="138" x2="91" y2="138" />
          <line x1="109" y1="138" x2="119" y2="138" />
        </g>
        <!-- Sleepy mouth (작은 곡선) -->
        <path d="M96 152 Q100 155 104 152" fill="none" stroke="#1F1A14" stroke-width="2.4" stroke-linecap="round" />
      </svg>
    </div>
    <div class="a-empty__title">{{ title }}</div>
    <div v-if="sub" class="a-empty__sub">{{ sub }}</div>
    <div v-if="$slots.action" class="a-empty__action"><slot name="action" /></div>
  </div>
</template>

<script>
export default {
  name: 'AEmpty',
  props: {
    title: { type: String, default: '데이터가 없습니다' },
    sub: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-empty {
  padding: 48px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-family: $p-font-body;

  &__icon { display: inline-flex; }
  &__title {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: -0.015em;
    color: $p-ink;
  }
  &__sub {
    font-size: 12px;
    color: $p-ink-mid;
    line-height: 1.5;
    max-width: 320px;
  }
  &__action { margin-top: 8px; }
}
</style>
